import { render, staticRenderFns } from "./ModuleAddressBook.vue?vue&type=template&id=04fc0aaf&"
import script from "./ModuleAddressBook.vue?vue&type=script&lang=js&"
export * from "./ModuleAddressBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports